import { Routes, Route } from "react-router";
import AppLayout from "../layout/AppLayout";
import LazyLoadWrapper from "../components/common/LazyLoadWrapper";
import Login from "../pages/auth/Login";
import Auth from "../pages/auth/Auth";
import Register from "../pages/auth/Register";
import RoleBasedRedirect from "../components/auth/RoleBasedRedirect";
import OnboardingGuard from "../components/auth/OnboardingGuard";
import UsersList from "../pages/admin/UsersList";
import CreateUser from "../pages/admin/CreateUser";
import UserDetails from "../pages/admin/UserDetails";
import AdminUserDetails from "../pages/admin/AdminUserDetails";
import InventoryDashboard from "../pages/admin/InventoryDashboard";
import ProductReport from "../pages/admin/ProductReport";
import Profile from "../pages/user/Profile";
import UserOnboarding from "../pages/user/UserOnboarding";
import Categories from "../pages/admin/inventory/Categories";
import Products from "../pages/admin/inventory/Products";
import AddProduct from "../pages/admin/inventory/AddProduct";
import InventoryHistory from "../pages/admin/inventory/InventoryHistory";
import ProductHistory from "../pages/admin/inventory/ProductHistory";
import AdminOrder from "../pages/admin/AdminOrder";
import OrdersList from "../pages/admin/OrdersList";
import WelcomePage from "../pages/user/WelcomePage";
import AdminCrm from "../pages/admin/AdminCrm";
import CrmUsersList from "../pages/admin/CrmUsersList";
import AdminRecharge from "../pages/admin/AdminRecharge";
import WeeklyShakeSetup from "../pages/admin/WeeklyShakeSetup";
import AdminRechargeList from "../pages/admin/AdminRechargeList";
import AddCustomer from "../pages/admin/AddCustomer";
import EditUser from "../pages/admin/EditUser";
import AdminRoute from "../components/auth/AdminRoute";
import MobileProfileNavigation from "../pages/user/MobileProfileNavigation";
import PersionalDetails from "../pages/user/elements/PersionalDetails";
import HealthConditions from "../pages/user/elements/HealthConditions";
import Tracker from "../pages/user/Tracker";
import HealthRiskAssessment from "../pages/user/HealthRiskAssessment";
import TrackerAnalytics from "../pages/user/TrackerAnalytics";
import Wellbeing from "../pages/common/Wellbeing";
import TermsAndConditions from "../pages/common/TermsAndConditions";
import PurchaseList from "../pages/admin/PurchaseList";
import PurchaseDetails from "../pages/admin/PurchaseDetails";
import OurBody from "../pages/user/OurBody";
import RechargeHistory from "../pages/user/elements/RechargeHistory";
import HealthDashboard from "../pages/user/health/HealthDashboard";
import DailyTracker from "../pages/user/DailyTracker";
import MyTransactions from "../pages/user/MyTransactions";
import MyShakeBalance from "../pages/user/MyShakeBalance";
import TransactionDetail from "../pages/user/TransactionDetail";
import StaffManagement from "../pages/admin/StaffManagement";
import ExpenseManagement from "../pages/admin/ExpenseManagement";
import ClassManagement from "../pages/admin/ClassManagement";
import SalesPage from "../pages/admin/SalesPage";
import SalesReport from "../pages/admin/SalesReport";
import ConsolidateReport from "../pages/admin/ConsolidateReport";
import NoTransactionList from "../pages/admin/NoTransactionList";
import AiLeads from "../pages/admin/AiLeads";
const AppRouter = () => {
  return (
    <Routes>
      {/* Auth Routes - No Layout */}
      <Route path="/login" element={<Login />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/register" element={<Register />} />
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/onboarding" element={<UserOnboarding />} />
      {/* App Routes with Layout */}
      <Route
        element={
          <OnboardingGuard>
            <AppLayout />
          </OnboardingGuard>
        }
      >
        {/* Common Pages */}
        <Route
          path="/wellbeing"
          element={
            <LazyLoadWrapper>
              <Wellbeing />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <LazyLoadWrapper>
              <TermsAndConditions />
            </LazyLoadWrapper>
          }
        />
        {/* Common Pages */}
        {/* Role-Based Home Page - Same path '/', different components based on role */}
        <Route
          path="/"
          element={
            <LazyLoadWrapper>
              <RoleBasedRedirect />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/profile"
          element={
            <LazyLoadWrapper>
              <MobileProfileNavigation />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/ourbody"
          element={
            <LazyLoadWrapper>
              <OurBody />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/profile/personal-details"
          element={
            <LazyLoadWrapper>
              <PersionalDetails />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/profile/health-conditions"
          element={
            <LazyLoadWrapper>
              <HealthConditions />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/profile/recharge-history"
          element={
            <LazyLoadWrapper>
              <RechargeHistory />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/health/overview"
          element={
            <LazyLoadWrapper>
              <HealthDashboard />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/tracker"
          element={
            <LazyLoadWrapper>
              <Tracker />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/tracker/analytics"
          element={
            <LazyLoadWrapper>
              <TrackerAnalytics />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/tracker/risk-assessment"
          element={
            <LazyLoadWrapper>
              <HealthRiskAssessment />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/daily-tracker"
          element={
            <LazyLoadWrapper>
              <DailyTracker />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/my-transactions"
          element={
            <LazyLoadWrapper>
              <MyTransactions />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/my-shake-balance"
          element={
            <LazyLoadWrapper>
              <MyShakeBalance />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/transaction/:transactionId"
          element={
            <LazyLoadWrapper>
              <TransactionDetail />
            </LazyLoadWrapper>
          }
        />
        <Route
          element={
            <LazyLoadWrapper>
              <AdminCrm />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/addcustomer"
          element={
            <LazyLoadWrapper>
              <AddCustomer />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/recharge"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <AdminRecharge />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/weekly-shake-setup"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <WeeklyShakeSetup />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/recharge-list"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <AdminRechargeList />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/consolidate-report"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <ConsolidateReport />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/purchase-topup"
          element={
            <LazyLoadWrapper>
              <PurchaseDetails />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/purchase-list"
          element={
            <LazyLoadWrapper>
              <PurchaseList />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/purchase-details/:purchaseId"
          element={
            <LazyLoadWrapper>
              <PurchaseDetails />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/adminorder"
          element={
            <LazyLoadWrapper>
              <AdminOrder />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/userlist"
          element={
            <LazyLoadWrapper>
              <UsersList />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/add-user"
          element={
            <LazyLoadWrapper>
              <CreateUser />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/edit-user/:userId"
          element={
            <LazyLoadWrapper>
              <EditUser />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/user-details/:userId"
          element={
            <LazyLoadWrapper>
              <AdminUserDetails />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/inventory-dashboard"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <InventoryDashboard />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/product-report"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <ProductReport />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        {/* User */}
        <Route
          path="/user/profile"
          element={
            <LazyLoadWrapper>
              <Profile />
            </LazyLoadWrapper>
          }
        />
        {/* User Details Page */}
        <Route
          path="/profile/:userId"
          element={
            <LazyLoadWrapper>
              <UserDetails />
            </LazyLoadWrapper>
          }
        />

        <Route
          path="/admin/categories"
          element={
            <LazyLoadWrapper>
              <Categories />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/products"
          element={
            <LazyLoadWrapper>
              <Products />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/product/add"
          element={
            <LazyLoadWrapper>
              <AddProduct />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/products/edit/:productId"
          element={
            <LazyLoadWrapper>
              <AddProduct />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/inventory-history"
          element={
            <LazyLoadWrapper>
              <InventoryHistory />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/product-history"
          element={
            <LazyLoadWrapper>
              <ProductHistory />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/orders"
          element={
            <LazyLoadWrapper>
              <OrdersList />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/welcome"
          element={
            <LazyLoadWrapper>
              <WelcomePage />
            </LazyLoadWrapper>
          }
        />
        {/* Admin */}
        <Route
          path="/admin/crm"
          element={
            <LazyLoadWrapper>
              <AdminCrm />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/crm-users"
          element={
            <LazyLoadWrapper>
              <CrmUsersList />
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/staff-management"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <StaffManagement />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/expense-management"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <ExpenseManagement />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/class-management"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <ClassManagement />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/sales"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <SalesPage />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/sales-report"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <SalesReport />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/no-transaction-list"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <NoTransactionList />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />
        <Route
          path="/admin/ai-leads"
          element={
            <LazyLoadWrapper>
              <AdminRoute>
                <AiLeads />
              </AdminRoute>
            </LazyLoadWrapper>
          }
        />

        {/* End Admin */}
      </Route>
    </Routes>
  );
};

export default AppRouter;
